"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFALUT_TEXT = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _AccountSwitcher = require("../Retrofit/AccountSwitcher");

var _head = _interopRequireDefault(require("lodash/head"));

var _react = _interopRequireWildcard(require("react"));

var _Pill = _interopRequireWildcard(require("../Pill"));

var _hook = require("./hook");

var DEFALUT_TEXT = 'All';
exports.DEFALUT_TEXT = DEFALUT_TEXT;

function getIsActive(activeAccount, ecUUID, retrofitAccountFilter) {
  if (!activeAccount.length && ecUUID === retrofitAccountFilter.ALL) return true;
  return activeAccount.map(function (item) {
    return item.ecUUID;
  }).includes(ecUUID);
}

function getPillShowText(activeAccount, list) {
  if (activeAccount.length === list.length) return DEFALUT_TEXT;
  var showText = (0, _Pill.getShowText)(activeAccount, 'email', {
    defalutText: DEFALUT_TEXT
  });
  return showText;
}

function getIsSelectedAll(activeAccount, ecUUID, list, retrofitAccountFilter) {
  var isIncludeAllOptions = activeAccount.some(function (item) {
    return item.ecUUID === retrofitAccountFilter.ALL;
  });
  if (isIncludeAllOptions) return false;
  var isAllOption = ecUUID === retrofitAccountFilter.ALL;
  var isSelectedAll = activeAccount.length + 1 === list.length - 1;
  if (isAllOption || isSelectedAll) return true;
}

function AccountPill(props, ref) {
  var accountList = props.accountList,
      onSelect = props.onSelect,
      defalutText = props.defalutText,
      currentActiveAccount = props.currentActiveAccount,
      retrofitAccountFilter = props.retrofitAccountFilter;

  var _useRebuildValue = (0, _hook.useRebuildValue)(currentActiveAccount),
      _useRebuildValue2 = (0, _slicedToArray2["default"])(_useRebuildValue, 2),
      activeAccount = _useRebuildValue2[0],
      setActiveAccount = _useRebuildValue2[1];

  var _useState = (0, _react.useState)(defalutText),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showText = _useState2[0],
      setShowText = _useState2[1];

  (0, _react.useEffect)(function () {
    if (currentActiveAccount.length) {
      onSelect(currentActiveAccount);
      setShowText((0, _head["default"])(currentActiveAccount).emailAddress);
    } else {
      onSelect([]);
      setShowText(DEFALUT_TEXT);
    }
  }, [currentActiveAccount]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setActiveAccount([]);

        if (!currentActiveAccount.length) {
          setShowText(DEFALUT_TEXT);
        }
      }
    };
  });
  var isHasActive = !!activeAccount.length;

  if (currentActiveAccount.length) {
    return /*#__PURE__*/_react["default"].createElement(_Pill.SinglePillItem, null, showText || defalutText);
  }

  return /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    isActive: isHasActive,
    showText: showText,
    defalutText: defalutText
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark text-lg"
  }, accountList.map(function (_ref, index) {
    var email = _ref.email,
        ecUUID = _ref.ecUUID,
        labelUUID = _ref.labelUUID;
    var isActive = getIsActive(activeAccount, ecUUID, retrofitAccountFilter);
    return /*#__PURE__*/_react["default"].createElement(_AccountSwitcher.AccountItem, {
      key: index,
      isShowUnreadNumber: false,
      email: email,
      active: isActive,
      activeColorCls: "text-primary",
      icon: isActive ? /*#__PURE__*/_react["default"].createElement(_Done["default"], {
        className: "text-primary"
      }) : null,
      onClick: function onClick() {
        var nextActiveAccount = [];

        if (!isActive) {
          var isSelectedAll = getIsSelectedAll(activeAccount, ecUUID, accountList, retrofitAccountFilter);

          if (isSelectedAll) {
            setActiveAccount([]);
            setShowText(DEFALUT_TEXT);
            onSelect([]);
            return;
          }

          nextActiveAccount = [].concat((0, _toConsumableArray2["default"])(activeAccount), [{
            email: email,
            ecUUID: ecUUID,
            labelUUID: labelUUID
          }]);
        } else {
          nextActiveAccount = activeAccount.filter(function (item) {
            return item.email !== email;
          });
        }

        var pillShowText = getPillShowText(nextActiveAccount, accountList);
        setActiveAccount(nextActiveAccount);
        setShowText(pillShowText);
        onSelect(nextActiveAccount);
      }
    });
  })));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(AccountPill);

exports["default"] = _default;
//# sourceMappingURL=AccountPill.js.map